/**
 * Calendar events: `calendar:` / `cal:` / `event:` / `events:` — title and location. Enter opens the calendar on that day.
 * Backed by the local search index (PLAN §12.2) through `deps.client`
 * (`index/indexClient.js` on desktop, `index/webIndexClient.js` on web).
 */
import { CalendarDays } from 'lucide-react';
import { createIndexProvider } from '../index/indexProvider';

export const SPEC = Object.freeze({ id: 'calendar', kinds: ['event'], prefixes: ['calendar', 'cal', 'event', 'events'], labelKey: 'palette.scope.calendar', icon: CalendarDays, order: 100, page: 'calendar.panel' });

/** @param {{ client: object }} deps */
export default function create(deps) {
  return createIndexProvider(SPEC, deps);
}
